function renderLandingProductsCarousels() {
    const carousels = document.querySelectorAll('.landing-products-swiper');

  if (carousels && carousels.length > 0) {
     carousels.forEach((carousel) => {
        const swiper = new Swiper(carousel, {
            draggable: true,
            cursor: 'grab',
            loop: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: carousel.querySelector('.swiper-button-next'),
                prevEl: carousel.querySelector('.swiper-button-prev'),
            },
        });
    });
  } 
}

function renderLandingReviewCarousels() {
    const carousels = document.querySelectorAll('.reviews-carousel');

    if (carousels && carousels.length > 0) {
       carousels.forEach((carousel) => {
        const swiper = new Swiper(carousel, {
            loop: true,
            draggable: true,
            breakpoints: {
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            },
            navigation: {
                nextEl: carousel.querySelector('.swiper-button-next'),
                prevEl: carousel.querySelector('.swiper-button-prev'),
            },
        });
    });
    }
}

  window.addEventListener("DOMContentLoaded", (event) => {
    renderLandingProductsCarousels();
    renderLandingReviewCarousels()
  });
    
  window.addEventListener("resize", (e) => {
    renderLandingProductsCarousels();
    renderLandingReviewCarousels()
  });

  document.addEventListener('shopify:section:load', function (event) {
    renderLandingProductsCarousels();
    renderLandingReviewCarousels()
  });

renderLandingProductsCarousels();
renderLandingReviewCarousels()
